import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.js';
import de from './locales/de/translation.js';
import fr from './locales/fr/translation.js';
import ar from './locales/ar/translation.js';
import es from './locales/es/translation.js';
import hi from './locales/hi/translation.js';
import id from './locales/id/translation.js';
import it from './locales/it/translation.js';
import ja from './locales/ja/translation.js';
import ko from './locales/ko/translation.js';
import ms from './locales/ms/translation.js';
import nl from './locales/nl/translation.js';
import pt from './locales/pt/translation.js';
import th from './locales/th/translation.js';
import vi from './locales/vi/translation.js';
import zh from './locales/zh/translation.js';

import enDynamic from './locales/en/dynamic.js';
import deDynamic from './locales/de/dynamic.js';
import frDynamic from './locales/fr/dynamic.js';
import arDynamic from './locales/ar/dynamic.js';
import esDynamic from './locales/es/dynamic.js';
import hiDynamic from './locales/hi/dynamic.js';
import idDynamic from './locales/id/dynamic.js';
import itDynamic from './locales/it/dynamic.js';
import jaDynamic from './locales/ja/dynamic.js';
import koDynamic from './locales/ko/dynamic.js';
import msDynamic from './locales/ms/dynamic.js';
import nlDynamic from './locales/nl/dynamic.js';
import ptDynamic from './locales/pt/dynamic.js';
import thDynamic from './locales/th/dynamic.js';
import viDynamic from './locales/vi/dynamic.js';
import zhDynamic from './locales/zh/dynamic.js';

void i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en, dynamic: enDynamic },
    de: { translation: de, dynamic: deDynamic },
    fr: { translation: fr, dynamic: frDynamic },
    ar: { translation: ar, dynamic: arDynamic },
    es: { translation: es, dynamic: esDynamic },
    hi: { translation: hi, dynamic: hiDynamic },
    id: { translation: id, dynamic: idDynamic },
    it: { translation: it, dynamic: itDynamic },
    ja: { translation: ja, dynamic: jaDynamic },
    ko: { translation: ko, dynamic: koDynamic },
    ms: { translation: ms, dynamic: msDynamic },
    nl: { translation: nl, dynamic: nlDynamic },
    pt: { translation: pt, dynamic: ptDynamic },
    th: { translation: th, dynamic: thDynamic },
    vi: { translation: vi, dynamic: viDynamic },
    zh: { translation: zh, dynamic: zhDynamic },
  },
  ns: ['translation', 'dynamic'],
  defaultNS: 'translation',
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: [
    'en',
    'de',
    'fr',
    'ar',
    'es',
    'hi',
    'id',
    'it',
    'ja',
    'ko',
    'ms',
    'nl',
    'pt',
    'th',
    'vi',
    'zh',
  ],
  interpolation: {
    prefix: '{',
    suffix: '}',
    escapeValue: false,
  },
  returnNull: false,
  returnEmptyString: false,
  saveMissing: false,
  react: {
    useSuspense: false,
  },
});

export default i18next;
